export default __webpack_public_path__ + "static/media/fact_sheet57.11b29836.png";